import React from 'react';

import classNames from 'classnames';

import { formatPrice } from '@shared/helpers';

import cls from './BalanceInformationBlock.module.css';
import { useBalanceInformationBlock } from './useBalanceInformationBlock';
import {
    FinancialIndicatorsInfoElement,
    FinancialInfoType,
} from '../../../UI/FinancialIndicatorsInfoElement/FinancialIndicatorsInfoElement';

interface BalanceInformationBlockProps {
    classes?: string;
}

export const BalanceInformationBlock = ({ classes }: BalanceInformationBlockProps) => {
    const { financial_info } = useBalanceInformationBlock();
    return (
        <div className={classNames(cls.BalanceInformationBlock, [classes])}>
            <FinancialIndicatorsInfoElement
                title={i18next.t(
                    'BalanceInformationBlock.return.financialIndicatorsInfoElement.title'
                )}
                value={formatPrice(Math.round(financial_info?.key_metrics.project_balance), {
                    withCurrency: true,
                    currencySign: financial_info?.currency?.sign,
                })}
                negativeNumber={financial_info.key_metrics.project_balance < 0}
                financialInfoType={FinancialInfoType.BALANCE_OBJECT}
                tooltipText={i18next.t(
                    'BalanceInformationBlock.return.financialIndicatorsInfoElement.tooltipText'
                )}
            />
        </div>
    );
};
